import React, { Children, useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Col, Container, Row } from "react-bootstrap";
import SelectDropDown from "../component/SelectDropDown";
import InputField from "../component/InputField";
import Form from "react-bootstrap/Form";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import OtherService from "../services/Other";
import AlertMsg from "../component/AlertMsg";
import RegistrationService from "../services/registration";
import { useNavigate } from "react-router-dom";
import Loader from "../component/Loader";
import AdminLayout from "../component/AdminLayout";
import { useSelector } from "react-redux";

const EventCreation = () => {
  const hierarchiesList = useSelector((state) => state.hierarchies.hierarchiesList);

  //ALL Use State
  const [loading, setLoading] = useState(true);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  //required Validation
  const [hierarchiesValidationError, setHierarchiesValidationError] = useState("");
  const [contentsValidationError, setContentsValidationError] = useState("");
  const [nameValidationError, setNameValidationError] = useState("");
  const [descriptionValidationError, setDescriptionValidationError] = useState("");
  const [typeValidationError, setTypeValidationError] = useState("");
  const [shortCodeValidationError, setShortCodeValidationError] = useState("");
  const [startDateValidationError, setStartDateValidationError] = useState("");
  const [endDateValidationError, setEndDateValidationError] = useState("");
  const [singleDayValidationError, setSingleDayValidationError] = useState("");
  const [activeValidationError, setactiveValidationError] = useState("");
  const [countryValidationError, setCountryValidationError] = useState("");
  const [stateValidationError, setStateValidationError] = useState("");
  const [cityValidationError, setCityValidationError] = useState("");
  const [contentState, setContentState] = useState({ id: "", title: "" });
  //Alert Box
  const [afterSubmissionResponse, setafterSubmissionResponse] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [isHierarchiesList, setIsHierarchiesList] = useState([]);
  const [isHierarchies, setIsHierarchies] = useState({ id: "", title: "" });
  const handleHierarchiesChange = (selectedValue) => {
    setIsHierarchies(selectedValue);
    setHierarchiesValidationError("");
  };
  //Contents
  const [isContentList, setIsContentList] = useState([]);
  const [isContents, setIsContents] = useState({ id: "", title: "" });
  //Type
  const [isContentType, setIsContentType] = useState({ id: "", title: "" });
  //Country
  const [isCountryList, setIsCountryList] = useState([]);
  const [contentCountry, setContentCountry] = useState({ id: "", title: "" });
  //State
  const [isStateList, setIsStateList] = useState([]);
  //City
  const [isCityList, setIsCityList] = useState([]);
  const [contentCity, setContentCity] = useState({ id: "", title: "" });
  //Input Fields Value Set//
  const [user, setUser] = useState({
    name: "",
    description: "",
    startDate: "",
    endDate: "",
    shortcode: "",
  });
  //Objects
  //Single Day
  const singleDay = [
    {
      id: "1",
      title: "Yes",
    },
    {
      id: "0",
      title: "No",
    },
  ];
  //Active

  const contentActiveList = [
    {
      id: "1",
      title: "Yes",
    },
    {
      id: "0",
      title: "No",
    },
  ];
  const ContentType = [
    {
      id: "1",
      title: "Event",
    },
    {
      id: "2",
      title: "Campaign",
    },
  ];
  //Content List
  useEffect(() => {
    const fetchContentData = async () => {
      try {
        // Content List
        const contentResponse = await OtherService.contentList();

        const contentListOptions = contentResponse.response.contentsList.map(
          (item) => ({
            id: item.contentId,
            title: item.contentTitle,
          })
        );

        setIsContentList(contentListOptions);
      } catch (error) {
        console.error("Content List Data Error");
      }
    };
    fetchContentData();
  }, []);

  //Hierarchies List (from redux store)
  useEffect(() => {
    setIsHierarchiesList(hierarchiesList || []);
  }, [hierarchiesList]);
  //All Countries
  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const response = await RegistrationService.allCountries();

        const countryNames = response.response.countriesDetails.map(
          (country) => ({
            id: country.id,
            title: country.name,
          })
        );
        setIsCountryList(countryNames);
      } catch (error) {
        console.error("Error fetching country data:");
      }
    };
    fetchCountryData();
  }, []);
  //All States
  useEffect(() => {
    const stateListFetch = async () => {
      if (contentCountry.id) {
        try {
          const stateListResponse = await RegistrationService.allStates(
            contentCountry.id
          );

          const statesDetails = stateListResponse.response.statesDetails;

          setIsStateList(
            statesDetails.map((item) => ({
              id: item.id,
              title: item.name,
            }))
          );
        } catch (error) {
          console.error("Error");
        }
      }
    };

    stateListFetch();
  }, [contentCountry.id]);
  //All City
  useEffect(() => {
    const fetchCityList = async () => {
      if (contentCountry.id && contentState.id) {
        try {
          const cityListResponse = await RegistrationService.allCities(
            contentCountry.id,
            contentState.id
          );

          setIsCityList(
            cityListResponse.response.citiesDetails.map((item) => ({
              id: item.id,
              title: item.name,
            }))
          );
          setLoading(false);
        } catch (error) {
          console.error("Error");
        }
      }
    };
    fetchCityList();
  }, [contentCountry.id, contentState.id]);
  //All Functions
  //Event Creation//
  const handleEventCreation = () => {
    let isValid = true;
    const validations = [
      {
        value: user.name,
        setter: setNameValidationError,
        message: "Name is required.",
      },
      {
        value: isHierarchies.id,
        setter: setHierarchiesValidationError,
        message: "Hierarchy is required.",
      },
      {
        value: isContents.id,
        setter: setContentsValidationError,
        message: "Content is required.",
      },
      {
        value: user.description,
        setter: setDescriptionValidationError,
        message: "Description is required.",
      },
      {
        value: isContentType.id,
        setter: setTypeValidationError,
        message: "Type is required.",
      },
      {
        value: user.shortcode,
        setter: setShortCodeValidationError,
        message: "Short Code is required.",
      },
      {
        value: user.startDate,
        setter: setStartDateValidationError,
        message: "Start Date is required.",
      },
      {
        value: user.endDate,
        setter: setEndDateValidationError,
        message: "End Date is required.",
      },
      {
        value: isSingleDay.id,
        setter: setSingleDayValidationError,
        message: "Single Day is required.",
      },
      {
        value: contentActive.id,
        setter: setactiveValidationError,
        message: "Active is required.",
      },
      {
        value: contentCountry.id,
        setter: setCountryValidationError,
        message: "Country Name is required.",
      },
      {
        value: contentState.id,
        setter: setStateValidationError,
        message: "State Name is required.",
      },
      {
        value: contentCity.id,
        setter: setCityValidationError,
        message: "City Name is required.",
      },
    ];
    validations.forEach(({ value, setter, message }) => {
      if (!value) {
        setter(message);
        isValid = false;
      } else {
        setter(""); // Clear the error message
      }
    });

    if (new Date(user.startDate) > new Date(user.endDate)) {
      isValid = false
      setEndDateValidationError("End date should be smaller than start date")
    }

    if (isValid) {
      setIsButtonLoading(true);
      const token = localStorage.getItem("access_token");
      const payload = {
        hierarchyId: isHierarchies.id,
        name: user.name,
        contents_id: isContents.id,
        programs_id: isContentType.id,
        description: user.description,
        type: isContentType.type,
        short_code: user.shortcode,
        start_date: user.startDate,
        end_date: user.endDate,
        single_day: isSingleDay.id,
        cog_countries_id: contentCountry.id,
        cog_states_id: contentState.id,
        cog_cities_id: contentCity.id,
        is_active: contentActive.id,
      };
      OtherService.eventCreation(payload, token)
        .then((res) => {

          if (!res.error) {
            setIsButtonLoading(false);
            setShowAlert(true);
            setafterSubmissionResponse({
              isSuccess: true,
              text: res.apiResponse,
            });
            setTimeout(() => {
              navigate("/event-list");
            }, 2000);
          } else {
            setIsButtonLoading(false);
            setShowAlert(true);
            setafterSubmissionResponse({
              isSuccess: false,
              text: res.errorMessage.reason.message,
            });
          }
        })
        .catch((e) => {
          setIsButtonLoading(false);
        });
    }
  };

  const navigate = useNavigate();

  const handleContentChange = (selectedValue) => {
    setIsContents(selectedValue);
    setContentsValidationError("");
  };

  const handleContentTypeChange = (selectedValue) => {
    setIsContentType(selectedValue);
    setTypeValidationError("");
  };

  const handleContentCountryNameChange = (selectedValue) => {

    setContentCountry(selectedValue);
    setCountryValidationError("");
    setContentState({ id: "", title: "" });
    setContentCity({ id: "", title: "" });
  };

  const handleContentStateNameChange = (selectedValue) => {
    setContentState(selectedValue);
    setStateValidationError("");
    setContentCity({ id: "", title: "" });
  };

  const handleContentCityNameChange = (selectedValue) => {
    setContentCity(selectedValue);
    setCityValidationError("");
  };

  const [contentActive, setContentActive] = useState({ id: "", title: "" });

  const handleActiveChange = (selectedValue) => {
    setContentActive(selectedValue);
    setactiveValidationError("");
  };

  const [isSingleDay, setIsSingleDay] = useState({ id: "", title: "" });

  const handleSingleDayChange = (selectedValue) => {
    setIsSingleDay(selectedValue);
    setSingleDayValidationError("");
  };

  //Input Fields Function//
  const handleNameInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
    if (e.target.name === "name") {
      setNameValidationError("");
    } else if (e.target.name === "description") {
      setDescriptionValidationError("");
    } else if (e.target.name === "startDate") {
      setStartDateValidationError("");
    } else if (e.target.name === "endDate") {
      setEndDateValidationError("");
    } else if (e.target.name === "shortcode") {
      setShortCodeValidationError("")
    }
  };

  return (
    <>
      {/* {loading && <Loader/>} */}
      <AdminLayout>
        <section className="mt-3 adminContentWrap adminWeb">
          <Container>
            <Row className="justify-content-center align-item-center h-100">
              <Col xs={12}>
                <div className="userInfoBox">
                  <div className="dashboard-title">
                    <h4>Please Create Your Event</h4>
                  </div>
                  <div className="dashboard-details">
                    <Row>
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Hierarchies"
                          requiredStar="*"
                          options={isHierarchiesList}
                          setSelectedValue={setIsHierarchies}
                          selectedValue={isHierarchies}
                          onChange={handleHierarchiesChange}
                          
                        />
                        {hierarchiesValidationError && (
                          <div className="error-message ">
                            {hierarchiesValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Contents"
                          requiredStar="*"
                          options={isContentList}
                          setSelectedValue={setIsContents}
                          selectedValue={isContents}
                          onChange={handleContentChange}
                        />
                        {contentsValidationError && (
                          <div className="error-message ">
                            {contentsValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          requiredStar="*"
                          inputFieldLabel="Name"
                          onChange={handleNameInput}
                          name="name"
                          value={user.name}
                        />
                        {nameValidationError && (
                          <div className="error-message">
                            {nameValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          requiredStar="*"
                          inputFieldLabel="Description"
                          name="description"
                          onChange={handleNameInput}
                          value={user.description}
                        />
                        {descriptionValidationError && (
                          <div className="error-message">
                            {descriptionValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Type"
                          requiredStar="*"
                          options={ContentType}
                          setSelectedValue={setIsContentType}
                          selectedValue={isContentType}
                          onChange={handleContentTypeChange}
                        />
                        {typeValidationError && (
                          <div className="error-message">
                            {typeValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <InputField
                          requiredStar="*"
                          inputFieldLabel="Shortcode"
                          name="shortcode"
                          value={user.shortcode}
                          onChange={handleNameInput}
                        />

                        {shortCodeValidationError && (
                          <div className="error-message">
                            {shortCodeValidationError}
                          </div>
                        )}

                      </Col>
                      <Col xs={12} lg={3}>
                        <Form.Label>
                          Start Date <span className="redStar">*</span>
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="startDate"
                          value={user.startDate}
                          onChange={handleNameInput}
                        />
                        {startDateValidationError && (
                          <div className="error-message">
                            {startDateValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <Form.Label>
                          End Date <span className="redStar">*</span>
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="endDate"
                          value={user.endDate}
                          onChange={handleNameInput}
                        />
                        {endDateValidationError && (
                          <div className="error-message">
                            {endDateValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Single Day"
                          requiredStar="*"
                          options={singleDay}
                          setSelectedValue={setIsSingleDay}
                          selectedValue={isSingleDay}
                          onChange={handleSingleDayChange}
                        />
                        {singleDayValidationError && (
                          <div className="error-message">
                            {singleDayValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Country"
                          requiredStar="*"
                          options={isCountryList}
                          setSelectedValue={setContentCountry}
                          selectedValue={contentCountry}
                          onChange={handleContentCountryNameChange}
                          page="searchFilter"
                        />
                        {countryValidationError && (
                          <div className="error-message">
                            {countryValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="State"
                          requiredStar="*"
                          options={isStateList}
                          setSelectedValue={setContentState}
                          selectedValue={contentState}
                          onChange={handleContentStateNameChange}
                          page="searchFilter"
                        />
                        {stateValidationError && (
                          <div className="error-message">
                            {stateValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="City"
                          requiredStar="*"
                          options={isCityList}
                          setSelectedValue={setContentCity}
                          selectedValue={contentCity}
                          onChange={handleContentCityNameChange}
                          page="searchFilter"
                        />
                        {cityValidationError && (
                          <div className="error-message">
                            {cityValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <SelectDropDown
                          labelName="Active"
                          options={contentActiveList}
                          setSelectedValue={setContentActive}
                          selectedValue={contentActive}
                          onChange={handleActiveChange}
                          requiredStar="*"
                        />
                        {activeValidationError && (
                          <div className="error-message">
                            {activeValidationError}
                          </div>
                        )}
                      </Col>
                      <Col xs={12} lg={3}>
                        <PrimaryGradientButton
                          buttonText={
                            isButtonLoading ? "Processing..." : "Submit"
                          }
                          className="mt-28"
                          onClick={handleEventCreation}
                          disabled={isButtonLoading}
                        />
                      </Col>
                      <Col xs={12} lg={6}></Col>
                      <Col xs={12} lg={6}>
                        {showAlert && (
                          <AlertMsg
                            alertBoxColor={
                              afterSubmissionResponse.isSuccess
                                ? "successAlert"
                                : "FailedAlert"
                            }
                            heading={
                              afterSubmissionResponse.isSuccess
                                ? "Success"
                                : "Failed"
                            }
                            text={afterSubmissionResponse.text}
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        </AdminLayout>

      {/* </div>
      </div> */}
    </>
  );
};

export default EventCreation;
